import React from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';

import {
  setOperationStatus,
  UI_OPERATION_STATUS_ERROR,
  CoreLink,
} from '@uncinc/react-drupal-core';

import {
  Button,
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import LogoImageVNL from '../../../../assets/images/VNL_logo.svg';
import { authorizeRiskMonitor } from '../../../../store/actions/SSO';

import { DEFAULT_LANGUAGE } from '../../../../config/constants';

import './style.scss';

const GrantRiskMonitor = () => {
  const PAGE_TITLE = 'Autoriseren Risico monitor | VeiligheidNL';
  const dispatch = useDispatch();
  const authorisationStatus = useSelector((state) => state.getIn(['ui', 'user', 'operations', 'authorize', 'status']));
  const urlParams = new URLSearchParams(window.location.search);
  const scopes = urlParams.get('scope') || '';

  const onGrantAccept = () => {
    dispatch(setOperationStatus('sso', 'authorize', null));
    dispatch(authorizeRiskMonitor());
  };

  return (
    <div className="RiskMonitor UserGrantRiskMonitor PageMinimal">
      <Helmet
        htmlAttributes={{
          lang: DEFAULT_LANGUAGE,
        }}
      >
        <title>{PAGE_TITLE}</title>
      </Helmet>
      <Container small>
        <div className="PageMinimal__top">
          <CoreLink className="Logo" href="https://www.veiligheid.nl">
            <img src={LogoImageVNL} alt="VeiligheidNL" />
          </CoreLink>
          <h1>SSO Authorise</h1>
        </div>
        <div className="PageMinimal__content">
          <div className="RiskMonitor__content">
            <div className="row">
              <div className="col-12">
                {authorisationStatus === UI_OPERATION_STATUS_ERROR && (
                  <div className="alert alert-danger">
                    Er is iets fout gegaan, neem contact met ons op.
                  </div>
                )}
                <p>Je geeft toestemming aan Risico monitor voor de volgende gegevens "scopes".</p>
                <ul>
                  {scopes.split(' ').map((scope) => {
                    return (
                      <li>{scope}</li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
          <div className="RiskMonitor__footer">
            <div className="row">
              <div className="col-12 col-lg-6 mb-2">
                <Button onClick={onGrantAccept}>
                  Accepteren
                </Button>
              </div>
              <div className="col-12 col-lg-6">
                <Button href="/" inverted>
                  Afwijzen
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default GrantRiskMonitor;
